import * as React from 'react';
import { addClass, Bem } from '../../utils/css.js';
import '../../constants.js';
import './Flex.scss.js';
import { FlexItem } from './FlexItem.js';

const DEFAULT_TAG = "div";
const { block } = Bem.create("vai-flex");
const Flex = React.forwardRef(function Flex2(props, ref) {
  const {
    component: Component = DEFAULT_TAG,
    flexDirection = "row",
    justifyContent = "flex-start",
    flexWrap = "nowrap",
    alignItems = "stretch",
    alignContent = "stretch",
    inline,
    className,
    dataTa,
    ...rest
  } = props;
  return /* @__PURE__ */ React.createElement(Component, {
    ref,
    className: addClass(block(inline && "inline-flex", `justify-content-${justifyContent}`, `flex-direction-${flexDirection}`, `flex-wrap-${flexWrap}`, `align-items-${alignItems}`, `align-content-${alignContent}`), className),
    "data-ta": dataTa,
    ...rest
  });
});
Flex.Item = FlexItem;

export { Flex };
